"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var Breadcrumbs = /** @class */ (function (_super) {
    __extends(Breadcrumbs, _super);
    function Breadcrumbs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Breadcrumbs.prototype.render = function () {
        var breadcrumbs = this.props.breadcrumbs;
        return (React.createElement("h1", { className: "u-colorGrey" }, breadcrumbs.map(function (crumb, idx) {
            var elem = null;
            if (crumb.link) {
                elem = (React.createElement(react_router_dom_1.Link, { key: crumb.text, to: crumb.link }, crumb.text));
            }
            else {
                elem = crumb.text;
            }
            if (idx != breadcrumbs.length - 1) {
                elem = [elem, " / "];
            }
            return elem;
        })));
    };
    return Breadcrumbs;
}(React.Component));
exports.default = Breadcrumbs;
//# sourceMappingURL=breadcrumbs.js.map